module.exports = __webpack_public_path__ + "img/comunicationmodalicon.7a357a17.svg";